/*
 * Copyright 2025 Intuition Robotics ltd
 */
import type {PsychologicalQuestion} from "./patient-data.js";

export const GADQuestions: PsychologicalQuestion[] = [
	{
		key: "anxious_frequency",
		description: "Feeling nervous, anxious, or on edge"
	},
	{
		key: "worry_frequency",
		description: "Not being able to stop or control worrying"
	}
];